import { Component, DestroyRef, OnInit, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { CompanyService } from "../../../shared/services/company.service";
import { empty } from "../../../functions";
import { catchError } from "rxjs/operators";
import { RoleTypes } from "../../../guards/roletypes";
import { Observable } from "rxjs";
import { AlertService } from "../../../shared/services/alert.service";
import { marker } from "@biesbjerg/ngx-translate-extract-marker";
import { AccountService } from "src/app/api/services";
import { Account } from "src/app/api/models";

@Component({
  selector: "app-modal-company-profile-account",
  templateUrl: "./modal-company-profile-account.component.html",
  styleUrls: ["./modal-company-profile-account.component.scss"],
  standalone: false,
})
export class ModalCompanyProfileAccountComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  isLoading = false;
  isProcessing = false;

  public data: any;

  faSpinner = faSpinner;

  profile = {
    id: "",
  };

  entity = {
    id: "",
    emailAddress: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
  };

  /**
   * Constructor
   *
   * @param activeModal
   */
  constructor(
    public activeModal: NgbActiveModal,
    public companyService: CompanyService,
    public accountService: AccountService,
    public alert: AlertService
  ) {}

  /**
   * Ng on init
   */
  ngOnInit(): void {
    this.profile = Object.assign({}, this.data.profile);
    this.entity = Object.assign({}, this.data.entity);
  }

  /**
   * Save data
   *
   * @constructor
   */
  Save() {
    if (empty(this.profile.id)) return;

    // Get all company accounts first to set updated accounts into
    this.companyService
      .apiGetCompanyAccounts(this.profile.id)
      .pipe(
        catchError(
          this.companyService.handleError("apiGetCompanyAccounts", false)
        ),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((result) => {
        // Proceed save
        if (result !== false) {
          const companyAccounts: any = result;

          // Update account
          if (!empty(this.entity.id)) {
            for (const i in companyAccounts) {
              const companyAccount = companyAccounts[i];
              if (companyAccount["accountId"] === this.entity.id) {
                companyAccounts[i] = {
                  account: this.entity,
                  accountId: this.entity.id,
                };
              }
            }

            // Post all updated accounts
            this.companyService
              .apiUpdateCompanyAccounts(this.profile.id, companyAccounts)
              .pipe(
                catchError(
                  this.companyService.handleError(
                    "apiUpdateCompanyAccounts",
                    false
                  )
                ),
                takeUntilDestroyed(this.destroyRef)
              )
              .subscribe((result) => {
                if (result !== false) {
                  this.activeModal.close(true);
                }
              });
          }
          // Create new account
          else {
            this.createCompanyAccount().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
              (response: any) => {
                if (null !== response) {
                  companyAccounts.push({
                    account: response,
                    accountId: response?.id,
                  });

                  // Post all updated accounts
                  this.companyService
                    .apiUpdateCompanyAccounts(this.profile.id, companyAccounts)
                    .pipe(
                      catchError(
                        this.companyService.handleError(
                          "apiUpdateCompanyAccounts",
                          false
                        )
                      ),
                      takeUntilDestroyed(this.destroyRef)
                    )
                    .subscribe((result) => {
                      if (result !== false) {
                        this.activeModal.close(true);
                      }
                    });
                }
              },
              (response: any) => {
                console.log(response);
                if (
                  response.error &&
                  response.error.title === "Account already exists"
                ) {
                  this.alert.error(
                    marker(
                      "Account already exists, please use another email address"
                    )
                  );
                } else {
                  this.alert.error("Something went wrong, please try again");
                }
              }
            );
          }
        } else {
          this.activeModal.close(false);
        }
      });
  }

  createCompanyAccount(): Observable<object> {
    const companyAccountNew: Account = {
      emailAddress: this.entity.emailAddress,
      firstName: this.entity.firstName,
      lastName: this.entity.lastName,
      phoneNumber: this.entity.phoneNumber,
      roles: [RoleTypes.Company],
      disableTargetGroupsCompanies: true,
      disableTargetGroupsJobs: true,
      disableTargetGroupsMeetDays: true,
    };

    return this.accountService.createAccount({ body: companyAccountNew });
  }
}
